<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.9999 16.9994L14.9999 22.8025H16.9999L16.9999 16.9994L22.8026 16.9994V14.9994L16.9999 14.9994L16.9999 9.19763H14.9999L14.9999 14.9994L9.19775 14.9994V16.9994L14.9999 16.9994Z"
        />
    </svg>
</template>
